'use client';

import { NEWEST, OLDEST } from '@/constants';
import { useSearch } from '@/app/search-context';
import Dropdown from './dropdown';

const options = [
  { value: NEWEST, label: NEWEST, },
  { value: OLDEST, label: OLDEST, },
];

export default function SortVideosClient({ className, }: { className: string }) {
  const { videoSort, setVideoSort, dataLoading, } = useSearch();

  return (
    <Dropdown
      className={className}
      options={options}
      value={videoSort || NEWEST}
      disabled={dataLoading}
      onChange={setVideoSort}
    />
  );
}
